export default function fetchWrapper(url, options) {
  const fetchOptions = options || {};
  // options.headers["Custom-Header"] = "Your custom header value here";
  return fetch(url, fetchOptions);
}

function handleResponse(response) {
  const contentType = response.headers.get("content-type");
  if (contentType.includes("application/json")) {
    return handleJSONResponse(response);
  }
  if (contentType.includes("text/html")) {
    return handleTextResponse(response);
  }
  // Other response types as necessary. I haven't found a need for them yet though.
  throw new Error(`Sorry, content-type ${contentType} not supported`);
}

function handleJSONResponse(response) {
  return response.json().then(json => {
    if (response.ok) {
      return json;
    }
    // throw new Error("Network response was not ok.");
    return Promise.reject(
      Object.assign({}, json, {
        status: response.status,
        statusText: response.statusText
      })
    );
  });
}

function handleTextResponse(response) {
  return response.text().then(text => {
    if (response.ok) {
      return text;
    }
    return Promise.reject(
      new Error({
        status: response.status,
        statusText: response.statusText,
        err: text
      })
    );
  });
}

export { handleResponse, handleJSONResponse, handleTextResponse };
